import { colors } from './tokens/color.js';
/**
 * @deprecated use `gray` instead
 */
export const grayScale = colors.gray;
/**
 * @deprecated use `red` instead
 */
export const redScale = {
    light: '#F59999',
    dark: '#B22D2D',
    ...colors.red
};
/**
 * @deprecated use `orange` instead
 */
export const orangeScale = {
    light: '#FDCF9B',
    dark: '#CC7410',
    ...colors.orange
};
/**
 * @deprecated use `yellow` instead
 */
export const yellowScale = {
    light: '#FFEB99',
    dark: '#EBBE0A',
    ...colors.yellow
};
/**
 * @deprecated use `teal` instead
 */
export const tealScale = {
    light: '#8AE2D6',
    dark: '#29A393',
    ...colors.teal
};
/**
 * @deprecated use `blue` instead
 */
export const blueScale = colors.blue;
/**
 * @deprecated use other color instead
 */
export const steelBlueScale = {
    DEFAULT: '#9AA5B2',
    100: '#F0F4F7',
    200: '#DFE5EB',
    300: '#B8C1CC',
    400: '#9AA5B2',
    500: '#768494',
    600: '#5D6A7A',
    700: '#475566',
    800: '#354252',
    900: '#19222E',
    950: '#10171F',
    1000: '#0B1117'
};
/**
 * @deprecated use other color instead
 */
export const blueSteelScale = steelBlueScale;
/**
 * @deprecated use `steelGray` instead
 */
export const steelGrayScale = colors['steel-gray'];
//# sourceMappingURL=color_palette.js.map